import "./certificates.css";
import iotCert from "../../assets/iot.jpg";       // IoT workshop
import dataSecCert from "../../assets/data.png"; // Data Security
import wipfli from "../../assets/wipfli.png"; // Wipfli Agile certificate
import google from "../../assets/google.png";
import ai from "../../assets/ai.png"; 
import kotlin from "../../assets/kotlin.png"; 

const Certificates = () => {
  return (
    <section id="certificate">
      <h1 className="certTitle">My Certificates</h1>
      <p className="certDesc">
        A showcase of the certifications I’ve earned through workshops and
        training programs.
      </p>

      <div className="certGrid">

        <div className="certCard">
          <img src={dataSecCert} alt="Data Security" className="certImg" />
          <h2>Data Security</h2>
          <p>March 2025</p>
        </div>
        <div className="certCard">
          <img src={wipfli} alt="Wipfli" className="certImg" />
          <h2>Problem solving using agile methodology</h2>
          <p>Jan 2025</p>
        </div>
         <div className="certCard">
          <img src={ai} alt="ai" className="certImg" />
          <h2>Generative AI</h2>
          <p>June 2024</p>
        </div>
        <div className="certCard">
          <img src={google} alt="Google Cybersecurity" className="certImg" />
          <h2>Google Cyber Security</h2>
          <p>Jan 2024</p>
        </div>
        <div className="certCard">
          <img src={kotlin} alt="kotlin" className="certImg" />
          <h2>Andriod Application Development with Kotlin</h2>
          <p>Dec 2023</p>
        </div>

        <div className="certCard">
          <img src={iotCert} alt="IoT Workshop" className="certImg" />
          <h2>Workshop on Internet of Things</h2>
          <p>Oct 2023</p>
        </div>


      </div>
    </section>
  );
};

export default Certificates;
